import styled from 'styled-components';

import RunMetadata from '~/components/RunMetadata';

export const RunMetaData = styled(RunMetadata)`
  margin-top: 16px;
  border-top: 1px solid ${({ theme }) => theme.colors.neutrals[97]};
  height: 44px;
`;
